var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "row main-nav" },
    _vm._l(_vm.menuItems, function(item) {
      return _c(
        "div",
        { staticClass: "col", class: item.toLocaleLowerCase() },
        [
          _c(
            "button",
            {
              staticClass: "btn",
              on: {
                click: function($event) {
                  _vm.selection.machine = item.toLocaleUpperCase()
                }
              }
            },
            [_vm._v(_vm._s(item.toLocaleUpperCase()))]
          )
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }